import React, { Component } from 'react';

export class TitleCaseFormat extends Component {

    formatElement(children) {

        //checks if it's a string, otherwise it'll just return the object
        function toTitleCase(item) {
            if (typeof item === 'string') {
                return item
                    //splitting strings up by space in case we get something with multiple words in it
                    .split(' ')
                    .map(string => {
                        //we don't want to format number strings
                        if (!string.match(/\d+/g)) {
                            //then we proceed to do the title casing for each word
                            return string
                                .toLowerCase()
                                .replace(/(\w+)/g, function (result) {
                                    return result[0].toUpperCase() + result.substring(1);
                                });
                        }
                        return string;
                    }).join(' ');
            }
            return item;
        }

        //recursively goes through each child element and finds any strings in the bottom level elements
        //then it proceeds to apply the toTitleCase function
        return React.Children.map(children, child => {
            if (!React.isValidElement(child)) {
                return toTitleCase(child)
            }
            if (child.props.children) {
                child = React.cloneElement(child, {
                    children: this.formatElement(child.props.children)
                });
            }
            return toTitleCase(child)
        });
    }

    render() {
        return (this.formatElement(this.props.children || null));
    }
}
